module.exports = __webpack_public_path__ + "static/img/dingbu.8435a39f.png";